import { useState, useEffect } from "react";
import axios from "../api/axios";
import styles from "./styles.module.css";
import QRCode from "qrcode.react";
import html2pdf from "html2pdf.js";
import { Link, useNavigate, useLocation, NavLink } from "react-router-dom";
import axio from "axios";

const VerificationResult = () => {
  const [country, setCountry] = useState("");
  const [userIP, setUserIP] = useState("");
  const [userAgent, setUserAgent] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const success = queryParams.get("success") === "true";
  const [isLoading, setIsLoading] = useState(true); // Add isLoading state

  //console.log(transRef);

  useEffect(async () => {
    if (success) {
      const queryParams = new URLSearchParams(window.location.search);
      const transRef = queryParams.get("transRef");

      // Send a GET request to the /transaction/${transRef}/verify endpoint
      try {
        setIsLoading(true);
        const response = await axios.get(`/updatepay/${transRef}`);
        //console.log(response.data);
        const savedDataString = localStorage.getItem("myData");
        // Convert the string back to an object
        const savedData = savedDataString ? JSON.parse(savedDataString) : null;
        let url = "";
        if (savedData.idtype === "demo") {
          url = "/demoapi";
        } else if (savedData.idtype === "nin") {
          url = "/ninapi";
        } else if (savedData.idtype === "vnin") {
          url = "/vnin";
        }
        try {
          const { data: res } = await axios.post(url, savedData);
          if (res.success) {
            setNdata(res.message);
            const codeData = {
              firstName: res.message.firstName,
              surname: res.message.surname,
              middleName: res.message.middleName,
              dateOfBirth: res.message.dateOfBirth,
              gender: res.message.gender,
              trustedNumber: res.message.trustedNumber,
            };
            const jsonData = JSON.stringify(codeData);
            setQRCodeData(jsonData);
            const im = `data:image/png;base64,${res.message.photograph}`;
            setImg(im);
            setShowCard(true);
            setIsLoading(false);
            const responset = await axios.get("https://ipapi.co/json/");
            const data = responset.data;
            const auditTrailData = {
              userId: savedData.email,
              action: `${savedData.idtype} Verification`,
              details: {
                ipAddress: data.ip, // Use the extracted user's IP address
                userAgent: navigator.userAgent,
                country: data.country_name,
              },
              status: "Successful",
              usertype: "Guest",
            };
            try {
              const response = await axios.post("/auditTrail", auditTrailData);
            } catch (error) {
              console.error("Error saving audit trail entry:", error);
            }
          } else {
            setError(res.message);
            setShowCard(false);
            setIsLoading(false);
            const auditTrailData = {
              userId: savedData.email,
              action: `${savedData.idtype} Verification`,
              details: {
                ipAddress: userIP, // Use the extracted user's IP address
                userAgent: userAgent,
                country: country,
              },
              status: "Failed",
              usertype: "Guest",
            };
            try {
              const response = await axios.post("/auditTrail", auditTrailData);
            } catch (error) {
              console.error("Error saving audit trail entry:", error);
            }
          }
        } catch (err) {
          setError(err.response?.data?.message || "An error occurred");
          setShowCard(false);
          setIsLoading(false);
          const auditTrailData = {
            userId: savedData.email,
            action: `${savedData.idtype} Verification`,
            details: {
              ipAddress: userIP, // Use the extracted user's IP address
              userAgent: userAgent,
              country: country,
            },
            status: "Failed",
            usertype: "Guest",
          };
          try {
            const response = await axios.post("/auditTrail", auditTrailData);
          } catch (error) {
            console.error("Error saving audit trail entry:", error);
          }
        }
      } catch (error) {
        console.error("Error verifying transaction:", error.message);
        navigate("/verification");
      }
    } else {
      navigate("/verification");
    }
    // Get the 'transRef' parameter from the query string
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axio.get("https://ipapi.co/json/");
        const data = response.data;
        setUserIP(data.ip); // Extract and set the user's IP address
        setCountry(data.country_name);
        // console.log(data.country_name);
      } catch (error) {
        console.log("Error fetching user data:", error);
      }
    };

    fetchUserData();

    // Get user agent
    setUserAgent(navigator.userAgent);
  }, []);

  const [img, setImg] = useState("");
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    dob: "",
    gender: "",
    idno: "",
    email: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [ndata, setNdata] = useState(null);
  const [qrCodeData, setQRCodeData] = useState("");
  const [showCard, setShowCard] = useState(false);
  const [showIdno, setShowIdno] = useState(true);

  const handleBackToVerification = () => {
    navigate("/verification");
  };

  const downloadPDF = () => {
    const element = document.getElementById("mycard");

    let opt = {
      margin: 1,
      filename: "verificationresult.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    html2pdf().set(opt).from(element).save();
  };

  return (
    <>
      <div className="relative isolate bg-white">
        <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2">
          <div className="relative px-6 pb-20 pt-16 sm:pt-20 lg:static lg:px-8 lg:py-36">
            <div className="mx-auto max-w-xl lg:mx-0 lg:max-w-lg">
              <div className="absolute inset-y-0 left-0 -z-10 w-full overflow-hidden bg-gray-100 ring-1 ring-gray-900/10 lg:w-1/2">
                <svg
                  className="absolute inset-0 h-full w-full stroke-gray-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]"
                  aria-hidden="true"
                >
                  <defs>
                    <pattern
                      id="83fd4e5a-9d52-42fc-97b6-718e5d7ee527"
                      width={200}
                      height={200}
                      x="100%"
                      y={-1}
                      patternUnits="userSpaceOnUse"
                    >
                      <path d="M130 200V.5M.5 .5H200" fill="none" />
                    </pattern>
                  </defs>
                  <rect
                    width="100%"
                    height="100%"
                    strokeWidth={0}
                    fill="white"
                  />
                  <svg
                    x="100%"
                    y={-1}
                    className="overflow-visible fill-gray-50"
                  >
                    <path d="M-470.5 0h201v201h-201Z" strokeWidth={0} />
                  </svg>
                  <rect
                    width="100%"
                    height="100%"
                    strokeWidth={0}
                    fill="url(#83fd4e5a-9d52-42fc-97b6-718e5d7ee527)"
                  />
                </svg>
              </div>
              <img
                src="/images/logo.png"
                alt="My Image"
                width={120}
                height={20}
              />

              <div className="border-t-4 border-b-4 border-blue-500 p-4 mt-4">
                <p className="text-md font-bold text-red-500">NOTICE</p>

                <div className="pt-5">
                  <h4 className="text-2xl pb-3">Generating a vNIN</h4>
                  <p>There are two ways to generate a virtual NIN:</p>
                </div>
                <div className="pt-5 text-2xl flex">
                  <svg width="41" height="40" fill="none">
                    <g
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2.75"
                      clipPath="url(#ussdhint_svg__a)"
                    >
                      <path d="M26.666 6.667H13.333c-.92 0-1.667.746-1.667 1.666v23.334c0 .92.747 1.666 1.667 1.666h13.333c.921 0 1.667-.746 1.667-1.666V8.333c0-.92-.746-1.666-1.666-1.666zm-8.332 1.666h3.333m-1.667 20v.017"></path>
                    </g>
                    <path fill="#fff" d="M20 15h21v10H20z"></path>
                    <path
                      fill="#262626"
                      d="M22.29 17.682l-.137 1.305 1.313-.372.102.728-1.227.11.797 1.062-.663.359-.578-1.145-.516 1.142-.69-.356.789-1.063-1.22-.113.116-.724 1.289.372-.137-1.305h.762zM26.511 23h-.806v-3.216c0-.107 0-.214.003-.322l.007-.314c.004-.103.01-.2.017-.294-.048.052-.107.11-.178.17a11.13 11.13 0 01-.219.192l-.574.458-.403-.509 1.483-1.162h.67V23zm5.028 0h-3.384v-.605l1.296-1.313c.25-.255.457-.475.618-.66.162-.186.282-.363.36-.529.079-.166.119-.347.119-.543 0-.242-.07-.424-.209-.547-.139-.126-.322-.188-.55-.188-.216 0-.417.043-.602.13a2.795 2.795 0 00-.567.362l-.44-.53c.138-.118.286-.227.444-.325a2.289 2.289 0 011.203-.321c.316 0 .59.057.82.171a1.237 1.237 0 01.718 1.169c0 .269-.054.517-.16.745-.108.228-.26.454-.459.677-.198.22-.434.461-.707.721l-.865.844v.038h2.365V23zm3.814-3.855c0 .225-.045.421-.136.587a1.158 1.158 0 01-.376.41c-.157.105-.34.18-.547.226v.024c.399.05.7.175.902.376.205.2.308.466.308.796 0 .29-.07.549-.209.776a1.4 1.4 0 01-.639.534c-.287.13-.656.194-1.107.194a4.06 4.06 0 01-.755-.065 2.791 2.791 0 01-.657-.208v-.714a3.24 3.24 0 001.357.328c.417 0 .715-.078.892-.233.178-.157.267-.373.267-.65a.667.667 0 00-.14-.437c-.091-.114-.234-.199-.428-.256a2.66 2.66 0 00-.741-.085h-.441v-.646h.444c.29 0 .522-.035.697-.103a.767.767 0 00.38-.29.774.774 0 00.12-.431c0-.214-.07-.38-.209-.5-.139-.12-.345-.18-.619-.18-.168 0-.322.019-.461.058a2.085 2.085 0 00-.38.147 3.664 3.664 0 00-.331.191l-.386-.557c.189-.141.414-.26.676-.359a2.61 2.61 0 01.916-.147c.513 0 .908.11 1.187.332.278.218.416.512.416.881zm3.883.875l-.191.977h.923v.57h-1.033L38.66 23h-.609l.28-1.432h-.854L37.206 23h-.595l.264-1.432h-.855v-.57h.964l.195-.979h-.906v-.57h1.008l.274-1.443h.608l-.273 1.443h.861l.277-1.443h.591l-.273 1.443h.861v.57h-.97zm-1.65.977h.854l.195-.977h-.858l-.192.977z"
                    ></path>
                    <defs>
                      <clipPath id="ussdhint_svg__a">
                        <path fill="#fff" d="M0 0h40v40H0z"></path>
                      </clipPath>
                    </defs>
                  </svg>{" "}
                  <h4>Via USSD</h4>
                </div>
                <ul className="pt-5">
                  <li className="pl-20 pt-3">
                    To generate a Virtual NIN via USSD, dial <br />
                    <span className="text-green-700">
                      *996*3*Your NIN*{process.env.REACT_APP_CODE}#
                    </span>
                  </li>
                  <li className="pl-20 pt-3">
                    An SMS message will be sent back to you containing the
                    Virtual NIN generated for you.
                  </li>
                </ul>
                <div className="pt-5 text-2xl flex">
                  <svg width="40" height="40" fill="none">
                    <g
                      stroke="#2C3E50"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2.75"
                      clipPath="url(#apphint_svg__a)"
                    >
                      <path d="M26.666 6.667H13.333c-.92 0-1.667.746-1.667 1.666v23.334c0 .92.747 1.666 1.667 1.666h13.333c.921 0 1.667-.746 1.667-1.666V8.333c0-.92-.746-1.666-1.666-1.666zm-8.332 1.666h3.333m-1.667 20v.017"></path>
                    </g>
                    <defs>
                      <clipPath id="apphint_svg__a">
                        <path fill="#fff" d="M0 0h40v40H0z"></path>
                      </clipPath>
                    </defs>
                  </svg>{" "}
                  <h4>Through the NIMC app</h4>
                </div>
                <ul className="pt-5">
                  <li className="pl-20 pt-3">
                    Download the NIMC App- Click on "Get Virtual NIN"
                  </li>
                  <li className="pl-20 pt-3">
                    Select "Input Enterprise short-code" and type
                    {process.env.REACT_APP_CODE}
                  </li>
                  <li className="pl-20 pt-3">
                    Click "Submit" and your virtual NIN will be generated.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <form className="px-6 pb-24 pt-20 sm:pb-32 lg:px-8 lg:py-48 ">
            <div className="mx-auto max-w-xl lg:mr-0 lg:max-w-lg ">
              {!showCard && (
                <>
                  <h2 className="text-3xl font-bold tracking-tight text-gray-900">
                    Verification{" "}
                  </h2>

                  <div className="pt-4">
                    {error && (
                      <div className={"w-full px-2 " + styles.error_msg}>
                        {error}
                      </div>
                    )}
                  </div>
                  <div className="mt-8 flex justify-end">
                    <button
                      onClick={handleBackToVerification}
                      className="mt-4 rounded-md bg-blue-600 px-4 py-2 text-lg font-semibold text-white shadow-sm hover:bg-blue-500 focus:ring-2 focus:ring-blue-600 focus:outline-none focus:ring-offset-2 transition duration-150 ease-in-out"
                    >
                      Back to Verification
                    </button>
                  </div>
                </>
              )}
              {showCard && ndata && (
                <>
                  {isLoading ? (
                    // Loading state JSX goes here
                    <div className="loading-spinner">Loading...</div>
                  ) : (
                    <div
                      className="flex flex-col items-center justify-center mb-5"
                      id="mycard"
                    >
                      {/* Front side of the ID Card JSX goes here... */}
                      <div
                        className="bg-white shadow-lg rounded-lg overflow-hidden relative border-2 border-gray-300"
                        style={{ width: "550px", height: "320px" }} // Add border styling here
                      >
                        {/* Coat of Arms Placeholder */}
                        <img
                          className="h-8 w-8 absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                          src="coatofarms.png"
                          alt="Coat of Arms"
                          style={{ marginTop: "30px" }}
                        />

                        <div
                          className="px-6 py-8"
                          style={{ marginTop: "15px" }}
                        >
                          <div className="flex justify-between">
                            <div className="flex">
                              {/* User Image Placeholder - Made square */}
                              <img
                                className="h-32 w-32  mr-4"
                                src={img}
                                alt="User Photo"
                                style={{ objectFit: "cover" }}
                              />
                              <div className="text-left">
                                {/* Name and Details Placeholder */}
                                <div className="text-sm font-bold">
                                  Surname/Nom
                                </div>
                                <div className="text-sm mb-2">
                                  {ndata.surname}
                                </div>
                                <div className="text-sm font-bold">
                                  Given Names/Prénoms
                                </div>
                                <div className="text-sm mb-2">
                                  {ndata.firstName}, {ndata.middleName}
                                </div>
                                <div className="flex justify-start">
                                  <div className="mr-6">
                                    <div className="text-sm font-bold">
                                      Date of Birth
                                    </div>
                                    <div className="text-sm">
                                      {ndata.dateOfBirth}
                                    </div>
                                  </div>
                                  <div>
                                    <div className="text-sm font-bold">
                                      Sex/Sexe
                                    </div>
                                    <div className="text-sm">
                                      {ndata.gender}
                                    </div>
                                  </div>
                                </div>
                                <div className="text-sm mb-2">
                                  <span className="font-bold">Telephone:</span>{" "}
                                  {ndata.trustedNumber}
                                </div>
                              </div>
                            </div>
                            <div className="text-center">
                              {/* NGA Text above QR Code */}
                              <div className="text-xs font-bold mb-1">NGA</div>
                              {/* QR Code Placeholder 
                  <img
                    className="h-32 w-32"
                    src="https://via.placeholder.com/128/000000/FFFFFF/?text=QR+Code"
                    alt="QR Code"
                  />*/}
                              {qrCodeData && (
                                <div className="w-32 h-32">
                                  <QRCode value={qrCodeData} />
                                </div>
                              )}
                            </div>
                          </div>
                          {ndata.NIN && (
                            <div className="text-center">
                              {/* NIN Number Placeholder */}
                              <div className="text-sm font-bold">
                                National Identification Number (NIN)
                              </div>
                              <div className="text-4xl font-bold">
                                {ndata.NIN}
                              </div>
                            </div>
                          )}

                          <div className="flex items-center justify-center">
                            <img
                              src="nimc.png"
                              alt="Logo"
                              className="h-6 w-auto mr-2"
                            />
                            <div className="text-sm font-bold">
                              Verified at National Identity Management
                              Commission
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Back side of the ID Card */}
                      <div
                        className="bg-white shadow-lg rounded-lg overflow-hidden relative border-2 border-gray-300"
                        style={{ width: "550px", height: "320px" }} // Add border styling here
                      >
                        <div className="p-8">
                          <div className="flex flex-col items-center justify-center h-full">
                            <p className="text-xl font-bold text-center mb-4">
                              Disclaimer
                            </p>
                            <p className="text-base font-semibold text-center">
                              Trust, but verify.
                            </p>
                            <p className="text-base text-center px-4">
                              While every effort has been made to ensure the
                              accuracy of the verification process, it is
                              important to note that it may not be 100%
                              foolproof. The verification result should be
                              considered as an indication of verification status
                              rather than an absolute guarantee.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="flex flex-col items-center justify-center mb-20">
                    {/* <button onClick={downloadPDF}>Download PDF</button>*/}
                    <button
                      onClick={handleBackToVerification}
                      className="mt-4 rounded-md bg-blue-600 px-4 py-2 text-lg font-semibold text-white shadow-sm hover:bg-blue-500 focus:ring-2 focus:ring-blue-600 focus:outline-none focus:ring-offset-2 transition duration-150 ease-in-out"
                    >
                      Back to Verification
                    </button>
                  </div>
                </>
              )}
              <div className="border-t-4 border-b-4 border-blue-500 p-4 mt-4">
                {/* Navigation Bar */}
                <nav className=" flex justify-center space-x-8">
                  <NavLink to="/login">
                    <span className="cursor-pointer text-lg font-semibold text-gray-900 new-text">
                      Login
                    </span>
                  </NavLink>
                  <NavLink to="/privacy">
                    <span className="cursor-pointer text-lg font-semibold text-gray-900 new-text">
                      Privacy
                    </span>
                  </NavLink>
                </nav>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default VerificationResult;
